export const shortTermMemory = []; // { role: 'user' | 'assistant', content: string }

export function addToShortTerm(role, content) {
  shortTermMemory.push({ role, content });

  // Ограничим до 6 последних сообщений (3 реплики от каждого)
  if (shortTermMemory.length > 12) shortTermMemory.shift();
  if (typeof content === "string") {
    console.log(`🧠 [Краткосрочная] ${role}: ${content}`);
  } else {
    console.log(`🧠 [Краткосрочная] ${role}:`, content);
  }
}

export function clearShortTerm() {
  shortTermMemory.length = 0;
}

export function getShortTermContext() {
  return [...shortTermMemory]; // shallow copy
}

export function printShortTermMemory() {
  console.log("🧠 Краткосрочная память:");
  shortTermMemory.forEach((entry, index) => {
    console.log(`\n#${index + 1} — [${entry.role}]`);
    try {
      const parsed = JSON.parse(entry.content);
      console.dir(parsed, { depth: null });
    } catch {
      console.log(entry.content);
    }
  });
}
